export interface SourceCrop {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export const HERO_MASTER_SIZE = Object.freeze({ width: 1920, height: 1080 });
export const HERO_CARD_SIZE = Object.freeze({ width: 1280, height: 720 });
export const HERO_OPEN_GRAPH_SIZE = Object.freeze({ width: 1200, height: 630 });

export function fitCoverSourceRect(
  sourceWidth: number,
  sourceHeight: number,
  targetWidth: number,
  targetHeight: number,
): SourceCrop {
  if (
    ![sourceWidth, sourceHeight, targetWidth, targetHeight].every(
      (value) => Number.isFinite(value) && value > 0,
    )
  )
    throw new Error('Hero crop dimensions must be positive finite numbers.');
  const sourceAspect = sourceWidth / sourceHeight;
  const targetAspect = targetWidth / targetHeight;
  if (sourceAspect > targetAspect) {
    const width = sourceHeight * targetAspect;
    return { x: (sourceWidth - width) / 2, y: 0, width, height: sourceHeight };
  }
  if (sourceAspect < targetAspect) {
    const height = sourceWidth / targetAspect;
    return { x: 0, y: (sourceHeight - height) / 2, width: sourceWidth, height };
  }
  return { x: 0, y: 0, width: sourceWidth, height: sourceHeight };
}

export function validateHeroAssetShape(
  asset: { readonly width: number; readonly height: number; readonly contentType: string },
  role: 'hero16x9' | 'openGraph',
): string | null {
  const expected = role === 'hero16x9' ? HERO_CARD_SIZE : HERO_OPEN_GRAPH_SIZE;
  if (asset.width !== expected.width || asset.height !== expected.height)
    return `${role} must be exactly ${expected.width}×${expected.height}.`;
  if (asset.contentType !== 'image/webp' && asset.contentType !== 'image/png')
    return `${role} must use WebP or PNG.`;
  return null;
}
